import React from 'react';
import { Box } from '@mui/material';
import FeaturedBannerSection from '../components/FeaturedBannerSection';

import {
	useTranslation,
	useAllAudiences,
	useAllCustomCategories,
	useAllCollections,
	useNavigate,
	PublicStatisticsBar,
	CategoriesRow,
	Contents,
	SectionWrapper,
	PerksSection,
	SectionHeader,
	ContentWrapper,
	ImageHeader,
	Button,
	useApiFilteredContents,
	styled
} from '@eduvision/toolkit';
import headerImage from '../images/start-hero.png';
import dChallenge from '../images/Logo_DiversityChallenge_tapevisual.svg';
import BMFSFJ from '../images/Logo_BMFSFJ.svg';
const Relative = styled(Box)`
	position: relative;
`;


const credits = [
	{
		imageSrc: dChallenge,
		imageAlt: 'Diversity Challenge',
		imageWidth: 200
	},
	{
		imageSrc: BMFSFJ,
		imageAlt: 'BMFSFJ',
		imageWidth: 550
	}
];

const StyledContentWrapper = styled(ContentWrapper)`
	& .CategoriesSection{
      background-color: ${p=>p.theme.palette.secondary.main};
    }
`;

const LoggedOutView = (): JSX.Element => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const renderContent = React.useCallback(() => {
		const label = t('LoggedOutView.header.button');
		return label ? (
			<Button navigateTo="/pricing" m="1rem 0 0" variant="contained">
				{label}
			</Button>
		) : (
			<></>
		);
	}, [t]);

	const customCategories = useAllCustomCategories();

	const { data: priorityContents } = useApiFilteredContents({ contentHasPriority: true });

	const { data: collectionCategories } = useAllCollections();
	const sectionCategories = [
		...(collectionCategories ? collectionCategories : []),
		...(customCategories ? customCategories : []),
	];
	const allAudiences = useAllAudiences();

	const handleContentShowMoreClick = React.useCallback(
		(selectedAudienceId) => {
			const selectedAudience = allAudiences?.find((audience) => audience.id === selectedAudienceId);
			const link = `/contents/${selectedAudience?.type}`;
			navigate(link);
		},
		[navigate, allAudiences]
	);

	return (
		<StyledContentWrapper>
			<Relative>
				<ImageHeader
					height={40}
					src={headerImage}
					title={t('LoggedOutView.header.title')}
					subTitle={t('LoggedOutView.header.subTitle')}
					renderContent={renderContent}
				/>
				<PublicStatisticsBar />
			</Relative>
			<Box m={`0 0 1.5rem 0`} />
			<SectionWrapper>
				<Contents
					title={t('LoggedOutView.content.title')}
					subTitle={t('LoggedOutView.content.subTitle')}
					onShowMoreClick={handleContentShowMoreClick}
					contents={priorityContents}
					maxItems={6}
					buttonLabel={t('LoggedOutView.content.button')}
				/>
			</SectionWrapper>
			<SectionWrapper
				altBackground
				padding="2rem"
				flexDirection="column"
				className="CategoriesSection"
			>
				<SectionHeader
					alignItems="flex-start"
					title={t('LoggedOutView.categories.title')}
					subTitle={t('LoggedOutView.categories.subTitle')}
				/>
				<CategoriesRow data={sectionCategories || undefined} />
			</SectionWrapper>
			<FeaturedBannerSection />
			<PerksSection />
			
			<SectionWrapper
				m="10rem 0 0 0"
				style={{ justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap', gap: '60px' }}
			>
				{credits.map((credit, i) =>
					credit.imageSrc ? (
						<img
							key={i}
							src={credit.imageSrc}
							alt={credit.imageAlt}
							width={credit.imageWidth ?? 238}
						/>
					) : null
				)}
			</SectionWrapper>
			
		</StyledContentWrapper>
	);
};

export default LoggedOutView;
